import { useNavigate } from "react-router-dom";
import "./BackButton.css";

/**
 * BackButton — reusable back navigation component
 *
 * Props:
 *   to       — navigate to a specific path instead of history.back()
 *   label    — custom label (default: "Back")
 *   className — extra class names
 */
export default function BackButton({ to, label = "Back", className = "" }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) navigate(to);
    else navigate(-1);
  };

  return (
    <button
      className={`back-btn ${className}`}
      onClick={handleClick}
      aria-label={label}
    >
      <span className="back-btn-arrow">←</span>
      <span className="back-btn-label">{label}</span>
    </button>
  );
}